import * as swcHelpers from '@swc/helpers';
import { useBloomreach } from '../context/context.js';

function useBloomreachPageRoutes() {
    var ref, ref1;
    const { pageModel , preview  } = useBloomreach();
    if (!(pageModel === null || pageModel === void 0 ? void 0 : (ref = pageModel.page) === null || ref === void 0 ? void 0 : (ref1 = ref.models) === null || ref1 === void 0 ? void 0 : ref1.routes)) {
        return {
            routes: {}
        };
    }
    const { routes  } = pageModel.page.models;
    // In the new version of bloomreach in preview mode the params that
    // are added by the bloomreach API can cause issues for the root routes sometimes
    // because these are base routes that are usually joined with other paths
    let cleanedRoutes = routes;
    if (preview) {
        cleanedRoutes = Object.keys(routes).reduce((acc, key)=>{
            const route = routes[key].split('?')[0];
            return swcHelpers.objectSpread({}, acc, {
                [key]: route !== null && route !== void 0 ? route : ''
            });
        }, {});
    }
    return {
        routes: cleanedRoutes
    };
}

export { useBloomreachPageRoutes };
//# sourceMappingURL=use-bloomreach-page-routes.js.map
